import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDollarSign, FiPercent } = FiIcons;

const ReferralFeeInput = ({ 
  referralFeeType, 
  referralFeeValue, 
  onReferralFeeTypeChange, 
  onReferralFeeValueChange 
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Allow only numbers and decimal points
    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
      onReferralFeeValueChange(inputValue);
    }
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Referral fee
      </label>
      <div className="flex space-x-2">
        <div className="flex-1 relative">
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            {referralFeeType === 'amount' ? '$' : ''}
          </span>
          <input
            type="text"
            value={referralFeeValue}
            onChange={handleChange}
            placeholder="0.00"
            className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${
              referralFeeType === 'amount' ? 'pl-8' : 'pl-3'
            } ${referralFeeType === 'percentage' ? 'pr-8' : 'pr-3'}`}
          />
          {referralFeeType === 'percentage' && (
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
              %
            </span>
          )}
        </div>
        <div className="flex rounded-lg border border-gray-300 overflow-hidden">
          <button
            type="button"
            className={`flex items-center justify-center px-3 py-2 ${
              referralFeeType === 'amount'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
            onClick={() => onReferralFeeTypeChange('amount')}
          >
            <SafeIcon icon={FiDollarSign} className="text-lg" />
          </button>
          <button
            type="button"
            className={`flex items-center justify-center px-3 py-2 ${
              referralFeeType === 'percentage'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
            onClick={() => onReferralFeeTypeChange('percentage')}
          >
            <SafeIcon icon={FiPercent} className="text-lg" />
          </button>
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {referralFeeType === 'amount' ? 'Fixed amount' : 'Percentage of package price'}
      </p>
    </div>
  );
};

export default ReferralFeeInput;